import React from 'react';
import Button from './ui/Button';
import { getTalentPoolPathFromStorage } from '../../utils/talentPoolNavigation';

export default function PillFooter({ onNavigate }) {
  return (
    <footer className="px-6 py-8 bg-[#F6F6F4]">
      <div className="mx-auto max-w-6xl rounded-full border border-gray-300 bg-white px-6 py-4">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          {/* Left */}
          <Button type="button" variant="text" onClick={() => onNavigate('/')} className="text-left tracking-wide">
            CREATOR&apos;S ARCH
          </Button>

          {/* Center */}
          <nav className="flex flex-wrap items-center gap-x-5 gap-y-2 justify-start lg:justify-center">
            <Button type="button" variant="text" onClick={() => onNavigate(getTalentPoolPathFromStorage())} className="text-gray-700 hover:text-gray-900 font-medium">
              Talent Pool
            </Button>
            <Button type="button" variant="text" onClick={() => onNavigate('/learning-certification')} className="text-gray-700 hover:text-gray-900 font-medium">
              Academy
            </Button>
            <Button type="button" variant="text" onClick={() => onNavigate('/production-sourcing')} className="text-gray-700 hover:text-gray-900 font-medium">
              Sourcing
            </Button>
            <Button type="button" variant="text" onClick={() => onNavigate('/pitch-upload')} className="text-gray-700 hover:text-gray-900 font-medium">
              Pitching
            </Button>
            <Button type="button" variant="text" onClick={() => onNavigate('/funding-projects')} className="text-gray-700 hover:text-gray-900 font-medium">
              Funding
            </Button>
            <Button type="button" variant="text" onClick={() => onNavigate('/chat')} className="text-gray-700 hover:text-gray-900 font-medium">
              Chat
            </Button>
            <Button type="button" variant="text" onClick={() => onNavigate('/feedback')} className="text-gray-700 hover:text-gray-900 font-medium">
              Feedback Form
            </Button>
          </nav>

          {/* Right */}
          <p className="text-sm text-gray-600">
            © Creator&apos;s Arch 2026. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

